import { Col, Grid, Row, Space, Tabs } from "antd";
import { DownCircleOutlined } from "@ant-design/icons";
import React, { useContext, useEffect, useRef, useState } from "react";
// import { useGoogleAnalytics } from "shared-components/GlobalHooks/web/GoogleAnalytics.hook";
import { FullScreen } from "../../../Components/FullScreen/web";
import { Favorite } from "../../../Components/Property/Favorite/web";
import { FormButton } from "../../../Components/Property/InformationRequest/LeadButtons/FormButton/web";
import { InformationRequest } from "../../../Components/Property/InformationRequest/web";
import { PropComponentMode } from "../../../Components/Property/PropertyInterfaces";
import { PropertyMap } from "../../../Components/Property/PropertyMap/web";
import {
	hasStreetView,
	PropertyStreetView,
} from "../../../Components/Property/PropertyStreetView/web";
import { SocialShare } from "../../../Components/Property/SocialShare/web";
import { ConfigStateContext } from "../../../Contexts/Configurations/context";
import { useTheme } from "../../../Styles/ThemeHook";
import { PropertyModalFloorPlans } from "./PropertyModalFloorPlans/web";
import { PropertyModalPhotos } from "./PropertyModalPhotos/web";
import { PropertyModalTour3d } from "./PropertyModalTour3d/web";
import { PropertyModalVideo } from "./PropertyModalVideo/web";
import { PropertyModalWorkProgress } from "./PropertyModalWorkProgress/web";
import "./styles.less";

const { TabPane } = Tabs;
const { useBreakpoint } = Grid;

export function PropertyModal({
	propId = null,
	activeTab,
	mode = "auto",
	isDisabledProperty = false,
	onChangeTab,
	listing,
}: {
	propId?: any;
	activeTab: string;
	mode: PropComponentMode;
	isDisabledProperty?: boolean;
	onChangeTab: (tab: any) => void;
	listing: Listing;
}) {
	const {
		id,
		img,
		images,
		isProject,
		tour3d,
		latitude,
		longitude,
		pointType = false,
		files,
		youtube = listing.video,
	} = listing;
	const hasConstructionImages = images.some(e => e.tag == "construction_advances");
	const { country_code } = useContext(ConfigStateContext);
	const { theme } = useTheme();
	const screen = useBreakpoint();
	const [hasSV, setHasSV] = useState(false);
	// const GA = useGoogleAnalytics();
	const scrollArrowRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (window && typeof window.dispatchEvent === 'function') {
			window.dispatchEvent(new Event('resize'));
		}
	}, []);

	useEffect(() => {
		const fetchHasStreetView = async ({ latitude, longitude }) => {
			const value = await hasStreetView({ latitude, longitude });
			setHasSV(value);
		};

		fetchHasStreetView({ latitude, longitude });
	}, [latitude, longitude]);

	const callback = tab => {
		onChangeTab(tab);
		// GA.Event({
		// 	category: "user_event",
		// 	action: "prop_modal_tab",
		// 	label: tab,
		// });
	};
	const extrasButtons = (
		<Space size={theme.spacing.mdSpacing}>
			<Favorite id={id} isDisabledProperty={isDisabledProperty} />
			<SocialShare id={id} mode={mode} isDisabledProperty={isDisabledProperty} />
		</Space>
	);

	return (
		<FullScreen
			className={"property-modal-container"}
			offset={screen.lg ? theme.spacing.xxlSpacing * 2 : 0}>
			<Row className={"tabrow"} style={{ position: "relative" }}>
				<Col span={24} className={"content-column"}>
					<Tabs
						className="tabs-property-modal"
						activeKey={activeTab}
						onChange={callback}
						tabBarExtraContent={extrasButtons}
						tabBarGutter={theme.spacing.mdSpacing}>
						{tour3d && (
							<TabPane
								tab={"Tour 3d"}
								key="tour3d"
								disabled={!tour3d}
								className="pm-tab-pane black-pane">
								<Row>
									<Col span={24} lg={16}>
										<PropertyModalTour3d tour3dUrl={tour3d} />
									</Col>
								</Row>
							</TabPane>
						)}

						{!(images.length === 0 && !img) && (
							<TabPane
								tab={"Fotos"}
								key="photos"
								disabled={images.length === 0 && !img}
								className="pm-tab-pane black-pane">
								<Row
									className="row-photos-modal"
									onScroll={() => {
										if (!scrollArrowRef.current.classList.contains("hide"))
											scrollArrowRef.current.classList.add("hide");
									}}>
									<Col span={24} lg={16}>
										<PropertyModalPhotos
											mode={mode}
											img={img}
											images={images}
											isProject={isProject}
											listing={listing}
											isDisabledProperty={isDisabledProperty}
										/>
									</Col>
									<div className="scroll-arrow-container" ref={scrollArrowRef}>
										<Row>
											<Col span={24} lg={16}>
												<div className="scroll-arrow">
													<DownCircleOutlined />
												</div>
											</Col>
										</Row>
									</div>
								</Row>
							</TabPane>
						)}

						{youtube && (
							<TabPane
								tab={"Video"}
								key="video"
								disabled={!youtube}
								className="pm-tab-pane black-pane pm-tab-pane-video">
								<Row>
									<Col span={24} lg={16}>
										<PropertyModalVideo
											id={id}
											mode={mode}
											isProject={isProject}
											youtube={youtube}
										/>
									</Col>
								</Row>
							</TabPane>
						)}

						<TabPane
							tab={"Mapa"}
							key="map"
							className="pm-tab-pane pm-tab-pane-map"
							disabled={!latitude || !longitude}>
							<Row>
								<Col span={24}>
									<PropertyMap
										isProject={isProject}
										latitude={latitude}
										longitude={longitude}
										id={propId || id}
										pointType={pointType}
										width="100%"
										height="100%"
										mode={mode}
									/>
								</Col>
							</Row>
						</TabPane>

						{hasSV && (
							<TabPane
								disabled={!latitude || !longitude}
								tab={"Street View"}
								key="streetView"
								className="pm-tab-pane pm-tab-pane-map">
								<Row>
									<Col span={24}>
										<PropertyStreetView
											id={id}
											width={"100%"}
											height={"100%"}
											mode={mode}
											isProject={isProject}
											latitude={latitude}
											longitude={longitude}
										/>
									</Col>
								</Row>
							</TabPane>
						)}

						{files && files.length > 0 && (
							<TabPane
								tab={"Planos"}
								key="floorPlans"
								disabled={files.length == 0}
								className="pm-tab-pane pm-tab-pane-plans">
								<Row>
									<Col span={24} lg={16}>
										<PropertyModalFloorPlans
											id={Number(id)}
											files={files}
											isProject={isProject}
										/>
									</Col>
								</Row>
							</TabPane>
						)}

						{isProject && (
							<TabPane
								tab={"Avances de obra"}
								key="workProgress"
								disabled={!hasConstructionImages}
								className="pm-tab-pane black-pane pm-tab-pane-workprogress">
								<Row>
									<Col span={24} lg={16}>
										<PropertyModalWorkProgress data={images} />
									</Col>
								</Row>
							</TabPane>
						)}
					</Tabs>
				</Col>
				<Col className={"information-request-container"} span={0} lg={8}>
					<div className={"information-request-content"}>
						<InformationRequest
							id={id}
							mode={mode}
							showDisclaimer={false}
							disabled={isDisabledProperty}
							isProject={isProject}
						/>
					</div>
				</Col>
				<Col className={"information-request-container-mobile"} span={24} lg={0}>
					<FormButton id={id} size={"large"} isDisabledProperty={isDisabledProperty} />
				</Col>
			</Row>
		</FullScreen>
	);
}

